import { withInstall } from '@bigin/utils'
import Row from './src/row.vue'

export const BRow = withInstall(Row)
export default BRow

export * from './src/row'
